import {CropPreview, ImageError, ImageValue} from '@legit.health/ui';
import {TFunction} from 'i18next';

export default function ImageErrorItem({
  error,
  imageValue,
  t
}: {
  error: {name: string; pass: boolean; position: number};
  imageValue: ImageValue;
  t: TFunction;
}) {
  return (
    <ImageError
      key={error.position}
      failedImageCheck={error}
      imageNode={<CropPreview imageWithCrop={imageValue} />}
      cardHeaderTitle={t('ui:diagnosticReport.imageError.cardHeaderTitle')}
      renderCardSubheaderHeader={(instructionsKey) =>
        t(`ui:diagnosticReport.imageError.cardSubheaderHeader.${instructionsKey}`)
      }
      renderErrorDescription={(instructionsKey) =>
        t(`ui:diagnosticReport.imageError.errorDescription.${instructionsKey}`)
      }
      renderInstructionTitle={(instruction) =>
        t(`ui:diagnosticReport.imageError.instructions.${instruction}.title`)
      }
      renderInstructionDescription={(instruction) =>
        t(`ui:diagnosticReport.imageError.instructions.${instruction}.description`)
      }
      cardContentSolveProblemTitle={t(
        'ui:diagnosticReport.imageError.cardContentSolveProblemTitle'
      )}
    />
  );
}
